import React from 'react';
import './AssistantContextChip.css';

/**
 * "What the assistant understands right now."
 *
 * Says precisely which property, version, period, filter and selection are
 * active — it never claims the assistant "sees everything on this page",
 * because it does not: the page publishes references, and the server fetches
 * its own figures.
 *
 * Two states matter and are visually distinct:
 *   - LIVE     the current page context, which the next message will carry.
 *   - SNAPSHOT the context attached to an older result, shown for provenance.
 */
const AssistantContextChip = ({
  label,
  parts = [],
  isSnapshot = false,
  warning = null,
  canClearSelection = false,
  onClearSelection,
}) => {
  const text = label || parts.filter(Boolean).join(' · ');
  if (!text && !warning) return null;

  return (
    <div className={`assistant-context-chip ${isSnapshot ? 'assistant-context-chip--snapshot' : ''}`}>
      <span className="assistant-context-chip-eyebrow">
        {isSnapshot ? 'Context used for this result' : 'Assistant context'}
      </span>
      <span className="assistant-context-chip-text" title={text}>{text}</span>
      {canClearSelection && !isSnapshot && (
        <button
          type="button"
          className="assistant-context-chip-clear"
          onClick={onClearSelection}
          // Clearing the selection must not clear property/version scope —
          // the user is narrowing the question, not leaving the page.
          title="Clear the selected row (keeps property, version and period)"
        >
          Clear selection
        </button>
      )}
      {warning && <span className="assistant-context-chip-warning">{warning}</span>}
    </div>
  );
};

export default AssistantContextChip;
